module.exports = __webpack_public_path__ + "img/institution-building_y.28f26787.svg";